import React from 'react';

import { useSnackbar } from 'notistack';

import { Button, Typography } from '@mui/material';

import { SalesforceUserLicensePoolRequest, createSalesforceUserLicenseRequest } from '~/services/SalesforceService';

import { useGetSalesforceUserLicense } from '../hooks/useGetSalesforceUserLicense';

export default function SalesforceAccessRequest() {
  const { loading, userLicensePoolAccessData, error, refresh } = useGetSalesforceUserLicense();
  const { enqueueSnackbar } = useSnackbar();

  const handleRequestAccess = async () => {
    try {
      const response = await createSalesforceUserLicenseRequest({ licenseRequest: buildLicensePoolRequest() });
      if (response.status === 201) {
        enqueueSnackbar('Salesforce Access Granted', { variant: 'success' });
        refresh(); // Refresh the data to show updated license status
      } else {
        enqueueSnackbar('Failed to request Salesforce Access', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Failed to request Salesforce Access', { variant: 'error' });
    }
  };

  if (loading || error || !userLicensePoolAccessData) {
    return null;
  }

  const hasActiveAccess = Boolean(userLicensePoolAccessData.hasAccess || userLicensePoolAccessData.licensePoolRequest);

  const defaultAccessDurationMs = (): number => userLicensePoolAccessData.defaultAccessTime * 1000 * 60 * 60;

  const buildLicensePoolRequest = (): SalesforceUserLicensePoolRequest => ({
    userId: userLicensePoolAccessData.userId,
    startDateTime: new Date().toISOString(),
    endDateTime: new Date(Date.now() + defaultAccessDurationMs()).toISOString(),
    extensionCount: 0,
  });

  return (
    <>
      {!hasActiveAccess && (
        <Button variant="contained" color="primary" onClick={handleRequestAccess} sx={{ mb: 2 }}>
          Request Salesforce Access
        </Button>
      )}

      {hasActiveAccess && (
        <Typography variant="body2" sx={{ mb: 2 }}>
          Salesforce access is active.
        </Typography>
      )}

      <Typography variant="body2">
        {hasActiveAccess
          ? 'Please log in to Salesforce using Azure SSO.'
          : 'Request Salesforce access before logging in to Salesforce using Azure SSO.'}
      </Typography>
    </>
  );
}
